const articles = (): void => {
  const selectors = {
    articlesSection: '[data-articles]',
    articlesFilter: '[data-filter]',
    articlesContainer: '.articles__articles',
    article: '.article',
  };

  const classes = {
    //
  };

  let dataFilters: any = {};
  const url = document.querySelector('html')?.getAttribute('data-base-url');

  // Mobile breakpoint (matches lg breakpoint - typically 992px)
  const MOBILE_BREAKPOINT = 992;

  const setActiveFilters = (): void => {
    const queryString = window.location.search;
    dataFilters = Object.fromEntries(new URLSearchParams(queryString));

    for (const [key, value] of Object.entries(dataFilters)) {
      const filterElements = document.querySelectorAll(
        '[data-filter][data-filter-key="' + key + '"]'
      );
      filterElements.forEach((element: any) => {
        const elementType = element.getAttribute('data-filter-type');
        if (elementType == 'button') {
          const filterValue = element.getAttribute('data-filter-value');
          if (filterValue == value) {
            element.setAttribute('selected', 'selected');
          } else {
            element.removeAttribute('selected');
          }
        }
        if (elementType == 'select') {
          const filterOptions = element.querySelectorAll('option');
          const matchingFilterOption = element.querySelector(
            '[value="' + value + '"]'
          );
          if (matchingFilterOption) {
            filterOptions.forEach((option: any) => {
              option.removeAttribute('selected');
            });
            matchingFilterOption.setAttribute('selected', 'selected');
            element.value = value;
          }
        }
      });
    }
  };

  setActiveFilters();

  const loadPage = (): void => {
    let dataFiltersString = url + '?';
    for (const [key, value] of Object.entries(dataFilters)) {
      dataFiltersString = dataFiltersString + key + '=' + value + '&';
    }
    dataFiltersString = dataFiltersString.substring(
      0,
      dataFiltersString.length - 1
    );
    window.location.href = dataFiltersString;
  };

  const applyFilters = (filterKey: any, filterValue: any): void => {
    dataFilters[filterKey] = filterValue;
    loadPage();
  };

  const clearFilter = (filterKey: any): void => {
    delete dataFilters[filterKey];
    loadPage();
  };

  const handleMobilePostsPerPage = (section: HTMLElement): void => {
    const postsPerPageMobile = section.getAttribute('data-posts-per-page-mobile');
    if (!postsPerPageMobile) return;

    // Find the articles container within this section
    const articlesContainer = section.querySelector<HTMLElement>(selectors.articlesContainer);
    if (!articlesContainer) return;

    // Get all articles from the container (not the entire section)
    const articles = Array.from(articlesContainer.querySelectorAll<HTMLElement>(selectors.article));
    if (articles.length === 0) return;

    const mobileLimit = parseInt(postsPerPageMobile, 10);
    
    // Store original display values
    const originalDisplays = articles.map(article => {
      const computedStyle = window.getComputedStyle(article);
      return computedStyle.display;
    });

    const updateArticleVisibility = (): void => {
      const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

      articles.forEach((article, index) => {
        if (isMobile) {
          // Hide articles beyond the mobile limit
          if (index >= mobileLimit) {
            article.style.display = 'none';
          } else {
            // Restore original display value
            article.style.display = originalDisplays[index] || 'flex';
          }
        } else {
          // Show all articles on desktop - restore original display value
          article.style.display = originalDisplays[index] || 'flex';
        }
      });
    };

    // Initial update
    updateArticleVisibility();

    // Update on window resize
    let resizeTimeout: ReturnType<typeof setTimeout>;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateArticleVisibility, 100);
    });
  };

  const articlesSections = document.querySelectorAll<HTMLElement>(
    selectors.articlesSection
  );

  articlesSections.forEach((section) => {
    // Handle mobile posts per page
    handleMobilePostsPerPage(section);

    const filters = section.querySelectorAll<HTMLSelectElement>(
      selectors.articlesFilter
    );

    filters.forEach((filter) => {
      const filterType = filter.getAttribute('data-filter-type');
      if (filterType == 'button') {
        filter.addEventListener('click', () => {
          const filterKey = filter.getAttribute('data-filter-key');
          const filterValue = filter.getAttribute('data-filter-value');
          const filterStatus = filter.getAttribute('selected');
          if (filterStatus == 'selected' || filterValue == 'clear-filter') {
            clearFilter(filterKey);
          } else {
            applyFilters(filterKey, filterValue);
          }
        });
      }
      if (filterType == 'select') {
        filter.addEventListener('change', () => {
          const filterKey = filter.getAttribute('data-filter-key');
          const filterValue = filter.options[filter.selectedIndex].value;
          if (filterValue == 'clear-filter') {
            clearFilter(filterKey);
          } else {
            applyFilters(filterKey, filterValue);
          }
        });
      }
    });
  });
};

export default articles;
